export default __webpack_public_path__ + "locales/pt/InviteDialog.json?hash=b81e9679c5e427b6bdaf585133d45909";